import {
    all,
    apply,
    curry,
    filter,
    forEachObjIndexed,
    both,
    complement,
    isEmpty as isEmptyRamda,
    isNil,
    map,
    either,
    addIndex,
    fromPairs,
    adjust,
    toPairs,
    pipe,
    values
} from 'ramda';

export const pickAs = curry((schema, obj) => {
    let result = {};
    forEachObjIndexed((as, what) => {
        result[as] = obj[what]
    }, schema);
    return result;
});

export const notEmpty = both(complement(isEmptyRamda), complement(isNil));
export const isEmpty = either(isNil, isEmptyRamda);
export const mapIndexed = addIndex(map);
export const filterIndexed = addIndex(filter);

export const mapObjectKeys = curry((fn, obj) =>
    fromPairs(map(adjust(0, fn), toPairs(obj))));

export const filterObjectKeys = curry((pred, obj) =>
    pipe(toPairs, filter(apply(pred)), fromPairs)(obj));

export const isEmptyObjValues = (obj) => {
    return all(isEmpty, values(obj));
};
